import { render, staticRenderFns } from "./Layout2.vue?vue&type=template&id=751389c4&"
import script from "./Layout2.vue?vue&type=script&lang=js&"
export * from "./Layout2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports